// One chunk for each module. All components of a module use the same download.
export const loadDataManager = () => import(/* webpackChunkName: "datamanager" */ '../modules/DataManagerModule');
export const loadBusSched = () => import(/* webpackChunkName: "bussched" */ '../modules/BusSchedModule');
export const loadBusMap = () => import(/* webpackChunkName: "busmap" */ '../modules/BusMapModule');
export const loadSpiderMap = () => import(/* webpackChunkName: "spidermap" */ '../modules/SpiderMapModule');
export const loadSchematicMap = () => import(/* webpackChunkName: "schematicmap" */ '../modules/SchematicMapModule');

// The keys are the app paths in AppManager.
const loadersByApp = {
    datamanager: loadDataManager,
    bussched: loadBusSched,
    busmap: loadBusMap,
    spidermap: loadSpiderMap,
    schematicmap: loadSchematicMap
};

// Downloads the code of the given apps before they open.
export function prefetchModules(apps) {
    apps.forEach((app) => {
        const load = loadersByApp[app];

        if (undefined !== load) {
            // If a prefetch fails, the module tries again and shows the error when it opens.
            load().catch(() => { });
        }
    });
}
